import {BehaviorSubject, Subscription} from 'rxjs';
import ArtistModel from '../model/artist.model';
import {AfterViewInit, Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {MatPaginator, PageEvent} from '@angular/material/paginator';
import {debounceTime, distinctUntilChanged} from 'rxjs/operators';
import {ConfirmDialogComponent, ConfirmDialogModel} from './dialogs/confirm-dialog/confirm-dialog.component';
import ArtistService from '../api/artist/artist.service';
import {ActivatedRoute, Router} from '@angular/router';
import {MatDialog} from '@angular/material/dialog';
import {MatSnackBar} from '@angular/material/snack-bar';
import {MatInput} from '@angular/material/input';
import {MatSidenavContent} from "@angular/material/sidenav";

@Component({ selector: 'abstractlist', template: '' })
export abstract class CrudComponent implements OnInit, AfterViewInit, OnDestroy {
  protected itemsSubject = new BehaviorSubject<any[]>([]);
  public static ScrollContainer: MatSidenavContent;
  public items$ = this.itemsSubject.asObservable();

  protected loadingSubject = new BehaviorSubject<boolean>(false);
  public loading$ = this.loadingSubject.asObservable();

  protected querySubject = new BehaviorSubject<string>('');
  public query$ = this.querySubject.asObservable();

  public sort;
  public direction;
  public limit;
  public page;
  public topInit;

  public total: number;

  protected initialQueryEmit = true;

  protected deleteConfirmTitle = 'Element löschen';
  protected deleteConfirmText = 'Möchtest du das Element wirklich löschen?';

  protected scrollerSubscription: Subscription;

  @ViewChild(MatPaginator) paginator: MatPaginator;

  @ViewChild('queryInput') queryInput;

  public constructor(protected router: Router, protected route: ActivatedRoute,
                     protected dialog: MatDialog,
                     protected snackBar: MatSnackBar) {

  }

  ngOnInit(): void {
    this.route.queryParamMap.subscribe(queryParams => {
      this.page = (parseInt(queryParams.get('page'))) || 1;
      this.limit = parseInt(queryParams.get('limit')) || 15;
      this.sort = queryParams.get('sort');
      this.direction = queryParams.get('dir');
      this.topInit = queryParams.get('top');
      this.querySubject.next(
        queryParams.get('query') || ''
      );
      if(this.queryInput) {
        this.queryInput.nativeElement.value = queryParams.get('query');
      }
    });
  }

  ngAfterViewInit() {
    this.query$
      .pipe(debounceTime(500), distinctUntilChanged())
      .subscribe(query => {
        console.log('query changed');
        if (!this.initialQueryEmit) {
          this.page = 1;
          this.paginator.pageIndex = 0;
        }
        this.initialQueryEmit = false;
        this.updateParams();
        this.loadResults();
      });

    if(this.queryInput) {
      setTimeout(() => {
        this.queryInput.nativeElement.value = this.querySubject.getValue();
      }, 200);
    }

    setTimeout(() => {
      this.scrollerSubscription = CrudComponent.ScrollContainer.elementScrolled().subscribe(event => {
        console.log((event.target as any).scrollTop);
        this.router.navigate(
            [],
            {
              relativeTo: this.route,
              queryParams: { top: (event.target as any).scrollTop },
              replaceUrl: true,
              queryParamsHandling: 'merge', // remove to replace all query params by provided
            });
      });
    }, 500);

    let firstRun = true;
    this.items$.subscribe(items => {
      if(items && items.length > 0 && firstRun) {
        firstRun = false;
        setTimeout(() => {
          CrudComponent.ScrollContainer.getElementRef().nativeElement.scrollTop = this.topInit;
        }, 200);

      }
    });

  }

  queryChangeEvent(query: string) {
    this.querySubject.next(query);
  }

  sortBy(col: string) {
    if(this.sort == col) {
      if(this.direction == 'asc') {
        this.direction = 'desc';
      } else if(this.direction =='desc') {
        this.sort = '';
      }
    } else {
      this.sort = col;
      this.direction = 'asc';
    }
    this.updateParams();
    this.loadResults();
  }

  protected abstract loadResults();

  changePagination(event: PageEvent) {
    this.page = event.pageIndex + 1;
    this.limit = event.pageSize;
    this.updateParams();
    this.loadResults();
  }

  protected abstract delete(element);

  deleteElement(element: any) {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      maxWidth: "400px",
      data: {
        title: this.deleteConfirmTitle,
        message: this.deleteConfirmText
      } as ConfirmDialogModel
    });

    dialogRef.afterClosed().subscribe(dialogResult => {
      if (dialogResult) {
        this.delete(element).subscribe(result => {
          this.snackBar.open('Eintrag gelöscht');
          this.updateParams();
          this.loadResults();
        }, error => {
          this.snackBar.open('Fehler beim Löschen');
        });
      }
    });
  }

  public abstract addNew();

  protected updateParams() {
    let queryParams = {
      page: this.page,
      limit: this.limit,
      query: this.querySubject.getValue(),
      sort: this.sort,
      dir: this.direction,
    };

    this.router.navigate(
      [],
      {
        relativeTo: this.route,
        queryParams: queryParams,
        queryParamsHandling: 'merge', // remove to replace all query params by provided
      });
  }

  ngOnDestroy() {
    if(this.scrollerSubscription) {
      this.scrollerSubscription.unsubscribe();
    }
  }
}
